import { Component, ElementRef, input, computed, signal, viewChild } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { UserService } from '@libs/app.services/account/user.service';

@Component({
  selector: 'app-avatar',
  styleUrls: ['./avatar.scss'],
  templateUrl: `./avatar.html`,

  imports: [CommonModule],
})
export class AvatarComponent {
  image = viewChild<ElementRef>('image');
  size = input<string>('64');
  isHor = signal<boolean>(false);
  url$: Observable<string> = this.userService
    .selectAvatar()
    .pipe(tap((url: string) => this.buildImg(url || 'assets/identifiers/mascot-head.png')));

  sizePx = computed(() => `${this.size()}px`);
  radius = computed(() => `${+this.size() / 2}px`);
  constructor(private userService: UserService) {}

  buildImg(url: string) {
    const img = this.image().nativeElement;
    img.alt = 'avatar';
    img.onload = () => {
      if (img.width > 0 && img.height > 0) {
        this.isHor.set(img.width > img.height);
        img.style.height = 'auto';
        img.style.maxWidth = 'none';
        if (!this.isHor()) {
          img.style.width = this.sizePx();
        } else {
          img.style.height = this.sizePx();
        }
      }
    };
    setTimeout(() => (img.src = url), 500);
  }
}
